import React from 'react'
import { useDispatch } from 'hooks/use-redux'
import { useLocation, useNavigate } from 'react-router-dom'
import type { Location } from 'react-router-dom'
import Button from 'components/ui/button'
import ContactUsLink from 'components/ui/contact-us-link'
import Heading from 'components/ui/heading'
import ModalWindow from 'components/ui/modal-window'
import styles from './index.module.css'

const NeedMoreUsersOrTracksModal = (): React.ReactNode => {
  const dispatch = useDispatch()
  const location = useLocation()
  const navigate = useNavigate()

  const query = new URLSearchParams(location.search)
  const queryObj = {
    users: query.get('users') || '',
    tracks: query.get('tracks') || '',
  }
  return (
    <ModalWindow
      header={<Heading>Need more users or tracks?</Heading>}
      actions={
        <ContactUsLink intercomMsg="I’d like to discuss signing up for a high volume DISCO plan">
          <Button appearance="primary" caption="Contact us" />
        </ContactUsLink>
      }
      isOpen
      width="medium"
      onClose={() => {
        navigate('/settings/billing')
      }}
    >
      <div className={styles.needMoreUsersOrTracksModalDescription}>
        <span>
          Need more than {queryObj.users}{' '}
          <span>{Number(queryObj.users) > 1 ? 'users' : 'user'}</span>
          <span> or </span>
          <span>
            {Number(queryObj.tracks) >= 1000
              ? `${Number(queryObj.tracks) / 1000}k`
              : queryObj.tracks}
          </span>
          <span> </span>
          <span>{Number(queryObj.tracks) > 1 ? 'tracks' : 'track'}</span>
          <span>? Get in touch.</span>
        </span>
      </div>
    </ModalWindow>
  )
}

export default NeedMoreUsersOrTracksModal
